/**
 * Validation.js
 */
export const Validation = (function (){

    var validate = function(submit){

        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        
        // Loop over them and prevent submission
        Array.prototype.filter.call(forms, function(form) {
            
            /**
             * Add a field to the required elements that on submit
             * validates.
             */
            var elements = form.elements; 
            Array.prototype.filter.call(elements, function(element) {
                if(element.required) {
                  var div = document.createElement( 'div' ); 
                  div.classList.add("invalid-feedback");
                  div.classList.add("text-warning");
                  div.innerHTML = "This field is required."
                  element.parentNode.insertBefore( div, element.nextSibling );
                }
            });

            form.onsubmit = function(event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    form.classList.add('was-validated');
                }else{
                    submit()
                }
                
            }

        });
         
    }

    return {
        validate:validate
    }

}());


